/** Nothing links here from the site nav, so a typo would be a dead end nobody notices. */
export const UNVEILING_PATH = '/unveiling'
export const TWIN_PATH = '/unveiling/digital-twin'
export const REGISTER_PATH = '/unveiling/register'
/** Straight to the form: on a phone the hero copy stands between the page top and the panel. */
export const ENQUIRY_PATH = `${REGISTER_PATH}#enquiry`
/** The stage twin: no header above it. /unveiling/navigate is reached by typed URL only. */
export const NAVIGATE_TWIN_PATH = '/unveiling/navigate/twin'
export const UNLOCK_PATH = '/unveiling/api/unlock'

export type UnveilingSection = 'broadcast' | 'twin' | 'register'
